'use client'

import ConsoleShot from '@/components/console/ConsoleShot'
import IconGrid from '@/blocks/IconGrid'
import KeywordChip from '@/components/KeywordChip'
import { Button } from '@indxsearch/systm'
import { Ai_agent, Book, Github, Search_or_ask, Sliders_horizontal, Users } from '@indxsearch/pixl'
import styles from './ServerSection.module.css'

// Indx Server as a whole: a picture of the real console (npm run console:shots, re-run it when the
// console changes), and the whole product's icon list. The sections after it show one feature each.
export default function ServerSection() {
  return (
    <section id="indx-2" className={styles.wrapper} aria-labelledby="server-title">
      <div className={styles.text}>
        <span className={styles.eyebrow}>Indx Search Platform</span>
        <h2 id="server-title">A search platform with AI on both sides</h2>
        <p>
          An open-source server for your datasets and a console to configure them and see how visitors
          search. Its AI works on both sides: it answers your visitors&rsquo; questions from your own records,
          and tells you what to tune.
        </p>
      </div>
      <IconGrid className={styles.icons} />
      {/* The server is the public Indx repository (IndxServer/ is its subtree). */}
      <div className={styles.cta}>
        <Button variant="primary" href="https://github.com/indxSearch/Indx" iconLeft={<Github />}>Get it on GitHub</Button>
        <Button variant="secondary" href="https://docs.indx.co" iconLeft={<Book />}>Read the docs</Button>
      </div>
      <div className={styles.stage}>
        {/* What Indx does, in a few words each, on both sides of the picture and over its edges. */}
        {/* One for each feature section below, in their order. */}
        <KeywordChip icon={<Users/>} tone="mid" className={styles.chip} style={{ left: '3%', top: '16%' }}>See what your users are doing</KeywordChip>
        <KeywordChip icon={<Sliders_horizontal/>} className={styles.chip} style={{ left: 0, top: '58%' }}>Tune relevance without code</KeywordChip>
        <KeywordChip icon={<Search_or_ask/>} className={styles.chip} style={{ right: 0, top: '24%' }}>Answers questions, not just searches</KeywordChip>
        <KeywordChip icon={<Ai_agent/>} tone="mid" className={styles.chip} style={{ right: '3%', top: '66%' }}>AI that tells you what to tune</KeywordChip>
        {/* A browser reduced to its frame: three dots and the address, so the console reads as a web
            app without pretending to be any particular browser. */}
        <div className={styles.browser}>
          <div className={styles.bar} aria-hidden="true">
            <span className={styles.dots}><i/><i/><i/></span>
            <span className={styles.address}>localhost:5001/teams/demo/datasets/furniture/fields</span>
          </div>
          <ConsoleShot name="console" sizes="(max-width: 1440px) 100vw, 1440px" alt="The Indx Server console on the Field configuration page of a demo furniture catalogue." />
        </div>
      </div>
      <p className={styles.note}>The real console, on a demo furniture catalogue.</p>
    </section>
  )
}
